import { NgModule } from "@angular/core";

import { DetectViewportDirective } from "./detect-viewport.directive";

@NgModule({
    declarations: [DetectViewportDirective],
    exports: [DetectViewportDirective],
})
export class DetectViewportDirectiveModule {}
